import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { RouteComponentProps } from 'react-router';
import RouteRX from "./RouteRX";
import * as types from "../../constants/actionTypes";

class RouteRXLoggedIn extends RouteRX {

    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.componentWillUpdate();
    }

    componentWillUpdate(oldProps) {
        if (this.props.computedMatch) {
            if (!this.props.isLoggedIn) {
                let params = '';
                //debugger;
                //Handling query params after logged in.
                if (this.props.location && this.props.location.search) {
                    params = this.props.location.search;
                }
                this.props.setRedirectUrl(this.props.computedMatch.url, params);
            }
        }
    }

    render() {
        if (this.props.computedMatch) {
            if (this.props.isLoggedIn) {
                if (!this.props.hasMyChart) {
                    // in the event that we don't have MyChart where we should, just go back to the root of the site
                    //debugger;
                    return <Redirect push to="/" />;
                }
                else {
                    return super.render();
                }
            }
            else {
                return <Redirect push to='/login' />;
            }
        }
        else {
            return "";
        }
    }

}


const mapStateToProps = (state, ownProps) => {
    return {
        isLoggedIn: state.domain.li, 
        hasMyChart: ownProps.RequireMyChart ? state.domain.hm : true
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRedirectUrl: (currentURL, params) => {
            //debugger;
            dispatch({ type: types.SET_REDIRECT_URL, URL: currentURL, params });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteRXLoggedIn);

